export const SUPPORT_BOT_EXPERIMENT_ID = 'support-bot-canary-v1';
export const SUPPORT_BOT_ASSIGNMENT_VERSION = 4;
const SUPPORT_BOT_HASH_BUCKET_COUNT = 10_000;
const SUPPORT_BOT_BUCKET_COUNT = 10;
const DEVICE_ID_COOKIE = 'deviceId';
const DEVICE_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function cookieValue(name: string): string | undefined {
  if (typeof document === 'undefined') {
    return undefined;
  }
  const prefix = `${encodeURIComponent(name)}=`;
  const entry = document.cookie.split('; ').find((cookie) => cookie.startsWith(prefix));
  if (!entry) {
    return undefined;
  }
  try {
    return decodeURIComponent(entry.slice(prefix.length));
  } catch {
    return undefined;
  }
}

export function supportBotAssignmentKey(
  userId: string | number | null | undefined,
): string | undefined {
  const normalizedUserId = typeof userId === 'string' ? userId.trim() : userId;
  if (normalizedUserId !== null && normalizedUserId !== undefined && normalizedUserId !== '') {
    return `member:${normalizedUserId}`;
  }
  const deviceId = cookieValue(DEVICE_ID_COOKIE)?.trim().toLowerCase();
  return deviceId && DEVICE_ID_PATTERN.test(deviceId) ? `device:${deviceId}` : undefined;
}

export function supportBotBucket(assignmentKey: string): number {
  const normalizedAssignmentKey = /^device:/i.test(assignmentKey)
    ? `device:${assignmentKey.slice('device:'.length).toLowerCase()}`
    : assignmentKey;
  const input = `${SUPPORT_BOT_EXPERIMENT_ID}:${normalizedAssignmentKey}`;
  let hash = 0x811c9dc5;

  for (let index = 0; index < input.length; index += 1) {
    hash = Math.imul(hash ^ input.charCodeAt(index), 0x01000193);
  }

  const hashBucket = (hash >>> 0) % SUPPORT_BOT_HASH_BUCKET_COUNT;
  return Math.floor(hashBucket / (SUPPORT_BOT_HASH_BUCKET_COUNT / SUPPORT_BOT_BUCKET_COUNT));
}

export function supportBotProfile(eligible: boolean, assignmentKey: string | undefined) {
  return {
    supportBotBucket: eligible && assignmentKey ? String(supportBotBucket(assignmentKey)) : '',
    supportBotExperimentId: SUPPORT_BOT_EXPERIMENT_ID,
    supportBotAssignmentVersion: String(SUPPORT_BOT_ASSIGNMENT_VERSION),
    supportBotAssignmentKey: assignmentKey ?? '',
    supportBotClient: 'web',
  };
}
